import React from "react";
import { DeleteEmployee } from "../../../../services/EmployeeMaster/Employee.service";
import styles from "./DeleteEmployeeModal.module.css";
import { toast } from "react-toastify";

interface DeleteEmployeeModalProps {
  isOpen: boolean;
  onClose: () => void;
  onSuccess: () => void;
  employeeData: any;
}

const DeleteEmployeeModal: React.FC<DeleteEmployeeModalProps> = ({
  isOpen,
  onClose,
  onSuccess,
  employeeData,
}) => {
  if (!isOpen || !employeeData) return null;

  const handleDelete = async () => {
    try {
      const res = await DeleteEmployee(employeeData.id);
    toast.success(res?.data?.message || "Employee deleted successfully");
      onSuccess();
      onClose();
    } catch (error:any) {
         toast.error(
                  error?.response?.data?.message || "Something went wrong"
                );
      console.error("Error deleting employee:", error);
    }
  };

  return (
    <div className={styles.overlay}>
      <div className={styles.modal}>
        {/* Warning Icon */}
        <div className={styles.iconWrapper}>
          <svg
            className={styles.warningIcon}
            xmlns="http://www.w3.org/2000/svg"
            viewBox="0 0 24 24"
            fill="none"
            stroke="currentColor"
            strokeWidth="2"
            strokeLinecap="round"
            strokeLinejoin="round"
          >
            <path d="M10.29 3.86L1.82 18a2 2 0 0 0 1.71 3h16.94a2 2 0 0 0 1.71-3L13.71 3.86a2 2 0 0 0-3.42 0z" />
            <line x1="12" y1="9" x2="12" y2="13" />
            <line x1="12" y1="17" x2="12.01" y2="17" />
          </svg>
        </div>

        <h2 className={styles.title}>Delete Employee</h2>

        <p className={styles.message}>
          Are you sure you want to delete{" "}
          <strong>
            {employeeData.firstName} {employeeData.lastName}
          </strong>{" "}
          (Code: <strong>{employeeData.employeeCode}</strong>)?
        </p>

        <p className={styles.subMessage}>
          This action cannot be undone.
        </p>

        <div className={styles.actions}>
          <button className={styles.cancelBtn} onClick={onClose}>
            Cancel
          </button>
          <button className={styles.deleteBtn} onClick={handleDelete}>
            Yes, Delete
          </button>
        </div>
      </div>
    </div>
  );
};

export default DeleteEmployeeModal;